import { render, staticRenderFns } from "./PurchaseDetailHeader.vue?vue&type=template&id=9ac409b8&scoped=true&"
import script from "./PurchaseDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./PurchaseDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseDetailHeader.vue?vue&type=style&index=0&id=9ac409b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac409b8",
  null
  
)

export default component.exports